import * as React from "react";
import MotifProgressLoader from '@ey/motif-react-wrapper/ProgressLoader';
import styled from "styled-components";

const ProgressLoader = (props) => {
  return (
    <StyledMotifLoader>
      <MotifProgressLoader {...props}>
      </MotifProgressLoader>
    </StyledMotifLoader>
  );
};

const StyledMotifLoader = styled.section`
    width: 100%;
    .motif-progress-loader {
      height: 76vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .motif-progress-loader-type{
      position: unset !important;
      transform: unset !important;
    }
    
    .motif-progress-nested{
        text-align: center;
        margin-top: var(--spacing-large);
        padding: 0 var(--spacing-x-large) var(--spacing-x-large) var(--spacing-x-large);
    }
`;

export default ProgressLoader;
